/* 
需要keep-alive缓存的路由name集合
注：需要在该路由组件中script标签加上 name=""
*/
import { $t } from '@/i18n'
export const keepAliveRouterName = [
  'statistical-goods-index',
  'statistical-shop-index'
]

export const asyncRoute = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: $t('navModules.home'),
      icon: 'shouye',
      permission: 'HOME'
    }
  },
  /* 订单管理 */
  {
    path: '/order-manager',
    name: 'orderManager',
    redirect: '/order-manager/sale-order',
    meta: {
      title: $t('navModules.router.ordMgmt'),
      icon: 'dingdanguanli',
      permission: 'ORDER_MANAGER'
    },
    children: [
      /* 销售订单 */
      {
        path: '/order-manager/sale-order',
        name: 'saleOrder',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.salesOrd'),
          permission: 'SALE_ORDER'
        },
        children: [
          {
            path: '/order-manager/sale-order',
            name: 'saleOrderIndex',
            component: () => import('@/views/order-manager/sale-order'),
            meta: {
              title: $t('navModules.router.salesOrd'),
              permission: 'SALE_ORDER',
              showInBreadcrumb: false
            }
          },
          {
            path: '/order-manager/sale-order/detail',
            name: 'saleOrderDetail',
            hidden: true,
            component: () =>
              import('@/views/order-manager/sale-order/detail/index.vue'),
            meta: { title: $t('navModules.router.salesOrd'), permission: 'SALE_ORDER' }
          }
        ]
      },
      /* 售后订单 */
      {
        path: '/order-manager/after-sale-order',
        name: 'afterSaleOrder',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.afterOrd'),
          permission: 'AFTER_SALE_ORDER'
        },
        children: [
          {
            path: '/order-manager/after-sale-order',
            name: 'afterSaleOrderIndex',
            component: () => import('@/views/order-manager/after-sale-order'),
            meta: {
              title: $t('navModules.router.afterOrd'),
              permission: 'AFTER_SALE_ORDER',
              showInBreadcrumb: false
            }
          },
          {
            path: '/order-manager/after-sale-order/detail',
            name: 'AfterSaleOrderDetail',
            hidden: true,
            component: () =>
              import('@/views/order-manager/after-sale-order/detail/index.vue'),
            meta: { title: $t('navModules.router.afterDetails'), permission: 'AFTER_SALE_ORDER' }
          }
        ]
      },
      /* 异常订单 */
      {
        path: '/order-manager/exception-sale-order',
        name: 'exceptionSaleOrder',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.abnormalOrd'),
          permission: 'EXCEPTION_SALE_ORDER'
        },
        children: [
          {
            path: '/order-manager/exception-sale-order',
            name: 'exceptionSaleOrderIndex',
            component: () =>
              import('@/views/order-manager/exception-sale-order'),
            meta: {
              title: $t('navModules.router.abnormalOrd'),
              permission: 'EXCEPTION_SALE_ORDER',
              showInBreadcrumb: false
            }
          },
          {
            path: '/order-manager/exception-sale-order/detail',
            name: 'ExceptionSaleOrderDetail',
            hidden: true,
            component: () =>
              import('@/views/order-manager/exception-sale-order/detail/index.vue'),
            meta: { title: $t('navModules.router.abnormalDetails'), permission: 'EXCEPTION_SALE_ORDER' }
          }
        ]
      },
      // /* 客诉订单 */
      // {
      //   path: '/order-manager/complaint-order',
      //   name: 'complaintOrder',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: $t('navModules.orderManageComplaintOrder'),
      //     permission: 'COMPLAINT_ORDER'
      //   },
      //   children: [
      //     {
      //       path: '/order-manager/complaint-order',
      //       name: 'complaintOrderIndex',
      //       component: () => import('@/views/order-manager/complaint-order'),
      //       meta: {
      //         title: $t('navModules.orderManageComplaintOrder'),
      //         permission: 'COMPLAINT_ORDER',
      //         showInBreadcrumb: false
      //       }
      //     }
      //   ]
      // },
      // /* 催收订单 */
      // {
      //   path: '/order-manager/collection-order',
      //   name: 'collectionOrder',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: $t('navModules.orderManageComplaintOrder'),
      //     permission: 'COLLECTION_ORDER'
      //   },
      //   children: [
      //     {
      //       path: '/order-manager/collection-order',
      //       name: 'collectionOrderIndex',
      //       component: () => import('@/views/order-manager/collection-order'),
      //       meta: {
      //         title: $t('navModules.orderManageComplaintOrder'),
      //         permission: 'COLLECTION_ORDER',
      //         showInBreadcrumb: false
      //       }
      //     }
      //   ]
      // },
      /* 用户行为管理 */
      {
        path: '/order-manager/user-behavior-management',
        name: 'userBehaviorManagement',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.riskCtrOrd'),
          permission: 'USER_BEHAVIOR_MANAGEMENT'
        },
        children: [
          {
            path: '/order-manager/user-behavior-management',
            name: 'userBehaviorOrderIndex',
            component: () =>
              import('@/views/order-manager/user-behavior-management'),
            meta: {
              title: $t('navModules.router.riskCtrOrd'),
              permission: 'USER_BEHAVIOR_MANAGEMENT',
              showInBreadcrumb: false
            }
          },
          {
            path: '/order-manager/user-behavior-management/exception-door-record-details',
            name: 'exception-door-record-details',
            meta: {
              title: '异常开门记录详情',
              permission: 'USER_BEHAVIOR_MANAGEMENT'
            },
            component: () => import('@/views/order-manager/user-behavior-management/components/exception-open-door/details.vue')
          }
        ]
      },
      /* 操作日志 */
      {
        path: '/order-manager/operation-log',
        name: 'operationLog',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.operationLog'),
          permission: 'OPERATION_LOG_MANAGEMENT'
        },
        children: [
          {
            path: '/order-manager/operation-log',
            name: 'operationLogIndex',
            component: () => import('@/views/order-manager/operation-log'),
            meta: {
              title: $t('navModules.router.operationLog'),
              permission: 'OPERATION_LOG_MANAGEMENT',
              showInBreadcrumb: false
            }
          }
        ]
      }
    ]
  },
  // 系统消息
  {
    path: '/sys-notice',
    hidden: true,
    name: 'sysNotice',
    component: () => import('@/views/notice/index.vue'),
    meta: {
      title: $t('noticeModules.title'),
      icon: 'sysNotice',
      permission: 'SYSTEM_INFORM'
    }
  },
  //待办事项
  {
    path: '/to-do-list',
    name: 'toDoList',
    hidden: true,
    component: () => import('@/views/to-do-list/index.vue'),
    meta: {
      title: $t('headerModules.todo'),
      permission: 'SYSTEM_INFORM'
    }
  },
  //开发者配置
  {
    path: '/developer-configuration',
    name: 'developer-configuration',
    hidden: true,
    component: () => import('@/views/developer-configuration/index.vue'),
    meta: {
      title: $t('headerModules.developerConfig'),
      permission: 'SYSTEM_INFORM'
    }
  },
  // 统计管理
  {
    path: '/statistical-manager',
    name: 'statistical-manager',
    redirect: '/statistical-manager/statistical-shop',
    meta: {
      title: $t('navModules.router.statManage'),
      icon: 'tongjiguanli',
      permission: 'STATISTICAL_MANAGER'
    },
    children: [
      // {
      //   path: '/statistical-manager/shop-sign',
      //   name: 'shop-sign',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '店铺看板',
      //     permission: 'SHOP_SIGN'
      //   },
      //   children: [
      //     {
      //       path: '/statistical-manager/shop-sign',
      //       name: 'shop-sign-index',
      //       component: () => import('@/views/statistical-manager/shop-sign'),
      //       meta: {
      //         title: '店铺看板',
      //         permission: 'POINT_STATISTICAL',
      //         showInBreadcrumb: false
      //       }
      //     }
      //   ]
      // },
      /* 统计管理 */
      {
        path: '/statistical-manager/statistical-shop',
        name: 'statistical-shop',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.statManageStoreStatistics'),
          permission: 'POINT_STATISTICAL'
        },
        children: [
          {
            path: '/statistical-manager/statistical-shop',
            name: 'statistical-shop-index',
            component: () =>
              import('@/views/statistical-manager/statistical-shop'),
            meta: {
              title: $t('navModules.router.statManageStoreStatistics'),
              permission: 'POINT_STATISTICAL',
              showInBreadcrumb: false
            }
          }
        ]
      },
      /* 商品统计 */
      {
        path: '/statistical-manager/statistical-goods',
        name: 'statistical-goods',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.statManageProductStatistics'),
          permission: 'GOOD_STATISTICAL'
        },
        children: [
          {
            path: '/statistical-manager/statistical-goods',
            name: 'statistical-goods-index',
            component: () =>
              import('@/views/statistical-manager/statistical-goods'),
            meta: {
              title: $t('navModules.router.statManageProductStatistics'),
              permission: 'GOOD_STATISTICAL',
              showInBreadcrumb: false
            }
          },
          {
            path: '/statistical-manager/statistical-goods/detail',
            name: 'statistical-goods-detail',
            component: () =>
              import('@/views/statistical-manager/statistical-goods/detail'),
            meta: { title: $t('navModules.statManageProductStatDel'), permission: 'GOOD_STATISTICAL' }
          }
        ]
      },
      /* 营销统计 */
      // {
      //   path: '/statistical-manager/statistical-activity',
      //   name: 'statistical-activity',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '营销统计',
      //     permission: 'MARKET_STATISTICAL'
      //   },
      //   children: [
      //     {
      //       path: '/statistical-manager/statistical-activity',
      //       name: 'statistical-activity-index',
      //       component: () =>
      //         import('@/views/statistical-manager/statistical-activity'),
      //       meta: {
      //         title: '营销统计',
      //         permission: 'MARKET_STATISTICAL',
      //         showInBreadcrumb: false
      //       }
      //     }
      //   ]
      // }
    ]
  },
  // 店铺管理
  {
    path: '/shop-manager',
    name: 'shop-manager',
    meta: {
      title: $t('navModules.router.storeManager'),
      icon: 'dianpuguanli',
      permission: 'POINT_MANAGER'
    },
    redirect: '/shop-manager/shop-list',
    children: [
      {
        path: '/shop-manager/shop-list',
        name: 'shop-manager-shop-list',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.storeManager'),
          permission: 'POINT_MANAGER_LIST'
        },
        redirect: '/shop-manager/shop-list/index',
        children: [
          {
            path: '/shop-manager/shop-list/index',
            name: 'shop-manager-shop-list-index',
            component: () => import('@/views/shop-manager/shop-list/index.vue'),
            meta: {
              title: $t('navModules.router.storeManager'),
              showInBreadcrumb: false,
              permission: 'POINT_MANAGER_LIST'
            }
          },
          {
            path: '/shop-manager/shop-list/detail',
            name: 'shop-manager-shop-list-detail',
            component: () =>
              import('@/views/shop-manager/shop-list/detail.vue'),
            meta: {
              title: $t('common.detail'),
              permission: 'POINT_MANAGER_LIST'
            }
          }
        ]
      },
      {
        path: '/shop-manager/shop-monitoring',
        name: 'shop-manager-shop-monitoring',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.storeMonitoring'),
          permission: 'STORE_MONITORING'
        },
        redirect: '/shop-manager/shop-monitoring/index',
        children: [
          {
            path: '/shop-manager/shop-monitoring/index',
            name: 'shop-manager-shop-monitoring-index',
            component: () =>
              import('@/views/shop-manager/shop-monitoring/index.vue'),
            meta: {
              title: $t('navModules.router.storeMonitoring'),
              showInBreadcrumb: false,
              permission: 'STORE_MONITORING'
            }
          },
          {
            path: '/shop-manager/shop-monitoring/edit',
            name: 'shop-manager-shop-monitoring-edit',
            component: () =>
              import('@/views/shop-manager/shop-monitoring/edit.vue'),
            meta: {
              title: $t('storeModules.shopMonitoring.editTitle'),
              permission: 'STORE_MONITORING'
            }
          }
        ]
      },
      {
        path: '/shop-manager/operation-log',
        name: 'shop-manager-operation-log',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.orderManageOrderLog'),
          permission: 'OPERATION_LOG'
        },
        redirect: '/shop-manager/operation-log/index',
        children: [
          {
            path: '/shop-manager/operation-log/index',
            name: 'shop-manager-operation-log-index',
            component: () =>
              import('@/views/shop-manager/operation-log/index.vue'),
            meta: {
              title: $t('navModules.orderManageOrderLog'),
              showInBreadcrumb: false,
              permission: 'OPERATION_LOG'
            }
          }
        ]
      }
    ]
  },
  // 商品管理
  {
    path: '/goods-manager',
    name: 'goods-manager',
    meta: {
      title: $t('navModules.router.goodsManage'),
      icon: 'shangpinguanli',
      permission: 'GOODS_MANAGER'
    },
    redirect: '/goods-manager/commercial-goods',
    children: [
      {
        path: '/goods-manager/commercial-goods',
        name: 'goods-manager-commercial-goods',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.goodsLibrary'),
          permission: 'GOODS_MANAGER_STORE'
        },
        redirect: '/goods-manager/commercial-goods/index',
        children: [
          {
            path: '/goods-manager/commercial-goods/index',
            name: 'goods-manager-commercial-goods-index',
            component: () => import('@/views/goods-manager/commercial-goods/index.vue'),
            meta: {
              title: $t('navModules.router.goodsLibrary'),
              showInBreadcrumb: false,
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/add-goods',
            name: 'goods-manager-commercial-goods-add-goods',
            component: () => import('@/views/goods-manager/commercial-goods/add-goods.vue'),
            meta: {
              title: $t('productModules.merchantGoods.addGoods'),
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/create-goods',
            name: 'goods-manager-commercial-goods-create-goods',
            component: () => import('@/views/goods-manager/commercial-goods/components/create-goods.vue'),
            meta: {
              title: $t('productModules.merchantGoods.addGoods'),
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/goods-examine',
            name: 'goods-manager-commercial-goods-goods-examine',
            component: () => import('@/views/goods-manager/commercial-goods/goods-examine.vue'),
            meta: {
              title: $t('productModules.merchantGoods.goodsReview'),
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/create-virtual-goods',
            name: 'goods-manager-commercial-goods-create-virtual-goods',
            component: () => import('@/views/goods-manager/commercial-goods/virtual-goods/components/edit-virtual-goods/index.vue'),
            meta: {
              title: '新增虚拟商品',
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/details-virtual-goods',
            name: 'goods-manager-commercial-goods-details-virtual-goods',
            component: () => import('@/views/goods-manager/commercial-goods/virtual-goods/components/details-virtual-goods.vue'),
            meta: {
              title: '虚拟商品详情',
              permission: 'GOODS_MANAGER_STORE'
            }
          },
          {
            path: '/goods-manager/commercial-goods/virtual-grant-list',
            name: 'goods-manager-commercial-goods-virtual-grant-list',
            component: () => import('@/views/goods-manager/commercial-goods/virtual-goods/virtual-grant-list.vue'),
            meta: {
              title: '虚拟商品发放列表',
              permission: 'GOODS_MANAGER_STORE'
            }
          }
        ]
      },
      {
        path: '/goods-manager/common-template',
        name: 'goods-manager-common-template',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.generalTemplates'),
          permission: 'COMMON_TEMPLATE'
        },
        redirect: '/goods-manager/common-template/index',
        children: [
          {
            path: '/goods-manager/common-template/index',
            name: 'goods-manager-common-template-index',
            component: () =>
              import('@/views/goods-manager/common-template/index.vue'),
            meta: {
              title: $t('navModules.router.generalTemplates'),
              showInBreadcrumb: false,
              permission: 'COMMON_TEMPLATE'
            }
          },
          {
            path: '/goods-manager/common-template/edit',
            name: 'goods-manager-common-template-edit',
            component: () =>
              import('@/views/goods-manager/common-template/edit-template.vue'),
            meta: {
              title: $t('common.edit'),
              permission: 'COMMON_TEMPLATE'
            }
          }
        ]
      },
      {
        path: '/goods-manager/price-manager',
        name: 'goods-manager-price-manager',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.priceManagement'),
          permission: 'PRICE_MANAGER'
        },
        redirect: '/goods-manager/price-manager/index',
        children: [
          {
            path: '/goods-manager/price-manager/index',
            name: 'goods-manager-price-manager-index',
            component: () =>
              import('@/views/goods-manager/price-manager/index.vue'),
            meta: {
              title: $t('navModules.router.priceManagement'),
              showInBreadcrumb: false,
              permission: 'PRICE_MANAGER'
            }
          },
          {
            path: '/goods-manager/price-manager/detail',
            name: 'goods-manager-price-manager-detail',
            component: () =>
              import('@/views/goods-manager/price-manager/detail.vue'),
            meta: {
              title: $t('common.detail'),
              permission: 'PRICE_MANAGER',
              showInBreadcrumb: false
            }
          },
          {
            path: '/goods-manager/price-manager/add',
            name: 'goods-manager-price-manager-add',
            component: () =>
              import('@/views/goods-manager/price-manager/add.vue'),
            meta: {
              title: $t('productModules.priceManagement.addPAdjustment'),
              permission: 'PRICE_MANAGER'
            }
          }
        ]
      },
      {
        path: '/goods-manager/advent-goods',
        name: 'goods-manager-advent-goods',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.nearExpiryProduct'),
          permission: 'ADVENT_GOODS'
        },
        redirect: '/goods-manager/advent-goods/index',
        children: [
          {
            path: '/goods-manager/advent-goods/index',
            name: 'goods-manager-advent-goods-index',
            component: () => import('@/views/goods-manager/advent-goods/index.vue'),
            meta: {
              title: $t('navModules.router.nearExpiryProduct'),
              permission: 'ADVENT_GOODS'
            }
          },
          {
            path: '/goods-manager/advent-goods/add-near-expiry-product',
            name: 'goods-manager-advent-goods-add-near-expiry-product',
            hideChildrenInMenu: true,
            redirect: `/goods-manager/advent-goods/add-near-expiry-product`,
            meta: {
              title: $t('productModules.nearExpiryProduct.AddNearExpiryProduct'),
              permission: 'ADVENT_GOODS',
              showInBreadcrumb: true
            },
            children: [
              {
                path: '/goods-manager/advent-goods/add-near-expiry-product',
                name: 'goods-manager-advent-goods-add-near-expiry-product-index',
                component: () =>
                  import(
                    '@/views/goods-manager/advent-goods/components/add-near-expiry-product.vue'
                  ),
                meta: {
                  title: $t('productModules.nearExpiryProduct.AddNearExpiryProduct'),
                  permission: 'ADVENT_GOODS',
                  showInBreadcrumb: false
                }
              }
            ]
          }
        ]
      },
      {
        path: '/goods-manager/short-goods',
        name: 'goods-manager-short-goods',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.stockoutProduct'),
          permission: 'SHORT_GOODS',
          showInBreadcrumb: true
        },
        redirect: '/goods-manager/short-goods/index',
        children: [
          {
            path: '/goods-manager/short-goods/index',
            name: 'goods-manager-short-goods-index',
            component: () =>
              import('@/views/goods-manager/short-goods/index.vue'),
            meta: {
              title: $t('navModules.router.stockoutProduct'),
              permission: 'SHORT_GOODS',
              showInBreadcrumb: false
            }
          },
          {
            path: '/goods-manager/short-goods/relate-shop',
            name: 'goods-manager-short-goods-relate-shop',
            hideChildrenInMenu: true,
            redirect: `/goods-manager/short-goods/relate-shop`,
            meta: {
              title: $t('productModules.stockoutProduct.associatedStores'),
              permission: 'SHORT_GOODS',
              showInBreadcrumb: true
            },
            children: [
              {
                path: '/goods-manager/short-goods/short-shop-details',
                name: 'goods-manager-short-goods-short-shop-details',
                component: () =>
                  import(
                    '@/views/goods-manager/short-goods/components/short-shop-details.vue'
                    ),
                meta: {
                  title: $t('productModules.stockoutProduct.associatedStores'),
                  permission: 'SHORT_GOODS',
                  showInBreadcrumb: false
                }
              }
            ]
          },
          {
            path: '/goods-manager/short-goods/add-warning',
            name: 'goods-manager-short-goods-add-warning',
            hideChildrenInMenu: true,
            redirect: `/goods-manager/short-goods/add-warning`,
            meta: {
              title: $t('productModules.nearExpiryProduct.newProductWarningThreshold'),
              permission: 'SHORT_GOODS',
              showInBreadcrumb: true
            },
            children: [
              {
                path: '/goods-manager/short-goods/add-warning',
                name: 'goods-manager-short-goods-add-warning-index',
                component: () =>
                  import(
                    '@/views/goods-manager/short-goods/components/new-add-warning.vue'
                    ),
                meta: {
                  title: $t('productModules.nearExpiryProduct.newProductWarningThreshold'),
                  permission: 'SHORT_GOODS',
                  showInBreadcrumb: false
                }
              }
            ]
          }
        ]
      },
      {
        path: '/goods-manager/price-strategy',
        name: 'goods-manager-price-strategy',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.pricingStrategy'),
          permission: 'PRICE_STRATEGY'
        },
        redirect: '/goods-manager/price-strategy/index',
        children: [
          {
            path: '/goods-manager/price-strategy/index',
            name: 'goods-manager-price-strategy-index',
            component: () =>
              import('@/views/goods-manager/price-strategy/index.vue'),
            meta: {
              title: $t('navModules.router.pricingStrategy'),
              showInBreadcrumb: false,
              permission: 'PRICE_STRATEGY'
            }
          },
          {
            path: '/goods-manager/price-strategy/details',
            name: 'price-strategy-details',
            hidden: true,
            component: () =>
              import(
                '@/views/goods-manager/price-strategy/shop-components/price-strategy-detail.vue'
                ),
            meta: {
              title: $t('productModules.pricingStrategy.strategyDetails'),
              permission: 'PRICE_STRATEGY',
              showInBreadcrumb: false
            }
          },
          {
            path: '/goods-manager/price-strategy/add',
            name: 'price-strategy-add',
            hidden: true,
            component: () =>
              import(
                '@/views/goods-manager/price-strategy/price-components/add-price'
                ),
            meta: {
              title: $t('productModules.pricingStrategy.addPricingStrategy'),
              permission: 'PRICE_STRATEGY',
              showInBreadcrumb: false
            }
          },
          {
            path: '/goods-manager/price-strategy/add-shop-strategy',
            name: 'goods-manager-price-strategy-add-shop-strategy',
            component: () =>
              import(
                '@/views/goods-manager/price-strategy/shop-components/add-shop-strategy'
                ),
            meta: {
              title: $t('productModules.pricingStrategy.addStoreStrategy'),
              showInBreadcrumb: false,
              permission: 'PRICE_STRATEGY'
            }
          }
        ]
      },
      {
        path: '/goods-manager/goods-tax',
        name: 'goods-manager-goods-tax',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.goodsTax'),
          permission: 'GOODS_TAX'
        },
        redirect: '/goods-manager/goods-tax/index',
        children: [
          {
            path: '/goods-manager/goods-tax/index',
            name: 'goods-manager-goods-tax-index',
            component: () => import('@/views/goods-manager/goods-tax/index.vue'),
            meta: {
              title: $t('navModules.router.goodsTax'),
              showInBreadcrumb: false,
              permission: 'GOODS_TAX'
            }
          }
        ]
      }
    ]
  },
  // 营销管理
  // {
  //   path: '/marketing',
  //   name: 'marketing',
  //   meta: {
  //     title: '营销管理',
  //     icon: 'yingxiaoguanli',
  //     permission: 'MARKET_MANAGER'
  //   },
  //   redirect: '/marketing/activities-management',
  //   children: [
  //     {
  //       path: '/marketing/activities-management',
  //       name: 'marketing-activities-management',
  //       hideChildrenInMenu: true,
  //       meta: {
  //         title: '营销活动',
  //         permission: 'MARKET_MANEUVER',
  //         showInBreadcrumb: true
  //       },
  //       redirect: '/marketing/activities-management/index',
  //       children: [
  //         {
  //           path: '/marketing/activities-management/index',
  //           name: 'marketing-activities-management-index',
  //           component: () =>
  //             import('@/views/marketing/activities-management/index.vue'),
  //           meta: {
  //             title: '营销活动',
  //             permission: 'MARKET_MANEUVER',
  //             showInBreadcrumb: false
  //           }
  //         },
  //         {
  //           path: '/marketing/activities-management/add-or-edit',
  //           name: 'marketing-activities-management-add-or-edit',
  //           hideChildrenInMenu: true,
  //           meta: {
  //             title: '新增活动',
  //             permission: 'MARKET_MANEUVER',
  //             showInBreadcrumb: true // 添加面包屑显示
  //           },
  //           component: () =>
  //             import('@/views/marketing/activities-management/add-or-edit.vue')
  //         }
  //       ]
  //     },
  //     {
  //       path: '/marketing/coupon-management',
  //       name: 'marketing-coupon-management',
  //       hideChildrenInMenu: true,
  //       meta: {
  //         title: '卡券管理',
  //         permission: 'VOUCHER_MANAGER',
  //         showInBreadcrumb: true
  //       },
  //       redirect: '/marketing/coupon-management/index',
  //       children: [
  //         {
  //           path: '/marketing/coupon-management/index',
  //           name: 'marketing-coupon-management-index',
  //           component: () =>
  //             import('@/views/marketing/coupon-management/index.vue'),
  //           meta: {
  //             title: '卡券管理',
  //             permission: 'VOUCHER_MANAGER',
  //             showInBreadcrumb: false // 添加面包屑显示
  //           }
  //         },
  //         {
  //           path: '/marketing/coupon-management/addCoupon',
  //           name: 'marketing-coupon-management-addCoupon',
  //           hideChildrenInMenu: true,
  //           meta: {
  //             title: '新增卡券',
  //             permission: 'VOUCHER_MANAGER',
  //             showInBreadcrumb: true // 添加面包屑显示
  //           },
  //           component: () =>
  //             import('@/views/marketing/coupon-management/addCoupon/index.vue')
  //         },
  //         {
  //           path: '/marketing/coupon-management/add-success',
  //           name: 'marketing-coupon-management-add-success',
  //           meta: {
  //             title: '新增成功',
  //             permission: 'VOUCHER_MANAGER',
  //             showInBreadcrumb: false // 添加面包屑显示
  //           },
  //           component: () =>
  //             import(
  //               '@/views/marketing/coupon-management/addCoupon/add-success/index.vue'
  //               )
  //         },
  //         {
  //           path: '/marketing/coupon-management/detail',
  //           name: 'marketing-coupon-management-detail',
  //           hideChildrenInMenu: true,
  //           meta: {
  //             title: '卡券详情',
  //             permission: 'VOUCHER_MANAGER',
  //             showInBreadcrumb: true // 添加面包屑显示
  //           },
  //           component: () =>
  //             import('@/views/marketing/coupon-management/addCoupon/index.vue')
  //         }
  //       ]
  //     },
  //     // 日志管理
  //     {
  //       path: '/marketing/journal',
  //       name: 'marketing-journal',
  //       meta: {
  //         title: '日志管理',
  //         permission: 'MARKET_LOG_MANAGER'
  //       },
  //       component: () => import('@/views/marketing/journal/index.vue')
  //     },
  //     {
  //       path: '/marketing/member-manage',
  //       name: 'marketing-member-manage',
  //       meta: {
  //         title: '会员管理',
  //         permission: 'MEMBER_MANAGER'
  //       },
  //       component: () => import('@/views/marketing/member-list/index.vue')
  //     }
  //   ]
  // },
  //广告管理
  {
    path: '/advertisement-manage',
    name: 'advertisement-manage',
    meta: {
      title: $t('adManage.router.adManage'),
      icon: 'guanggaoguanli',
      permission: 'AD_MANAGE',
      showInBreadcrumb: true
    },
    redirect: '/advertisement-manage/ad-material',
    children: [
      {
        path: '/advertisement-manage/ad-material',
        name: 'advertisement-manage-ad-material',
        meta: {
          title: $t('adManage.router.adMaterial'),
          permission: 'AD_MANAGE'
        },
        component: () => import('@/views/advertisement-manage/ad-material/index.vue')
      },
      {
        path: '/advertisement-manage/ad-plan',
        name: 'advertisement-manage-ad-plan',
        meta: {
          title: $t('adManage.router.adPlan'),
          permission: 'AD_MANAGE',
          showInBreadcrumb: true
        },
        hideChildrenInMenu: true,
        redirect: '/advertisement-manage/ad-plan/index',
        children: [
          {
            path: '/advertisement-manage/ad-plan/index',
            name: 'advertisement-manage-ad-plan-index',
            meta: {
              title: $t('adManage.router.adPlan'),
              permission: 'AD_MANAGE',
              showInBreadcrumb: false
            },
            component: () => import('@/views/advertisement-manage/ad-plan/index.vue')
          },
          {
            path: '/advertisement-manage/ad-plan/add',
            name: 'advertisement-manage-ad-plan-add',
            meta: {
              title: $t('adManage.router.addAdPlan'),
              permission: 'AD_MANAGE'
            },
            component: () => import('@/views/advertisement-manage/ad-plan/edit-ad-plan.vue')
          }
        ]
      }
    ]

  },
  // 理货管理
  {
    path: '/talling-manager',
    name: 'talling-manager',
    meta: {
      title: $t('navModules.router.merchManage'),
      icon: 'lihuoguanli',
      permission: 'TALLING_MANAGER'
    },
    redirect: '/talling-manager/shop-stock',
    children: [
      {
        path: '/talling-manager/shop-stock',
        name: 'talling-manager-shop-stock',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.merchManageStoreInventory'),
          permission: 'POINT_STOCK'
        },
        redirect: '/talling-manager/shop-stock/index',
        children: [
          {
            path: '/talling-manager/shop-stock/index',
            name: 'talling-manager-shop-stock-index',
            component: () => import('@/views/talling-manager/shop-stock/index'),
            meta: {
              title: $t('navModules.router.merchManageStoreInventory'),
              showInBreadcrumb: false,
              permission: 'POINT_STOCK'
            }
          }
        ]
      },
      {
        path: '/talling-manager/replenishment-inquiry',
        name: 'talling-manager-replenishment-inquiry',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.merchManageMerchOrderSearch'),
          permission: 'REPLENISHMENT_INQUIRY'
        },
        redirect: '/talling-manager/replenishment-inquiry/index',
        children: [
          {
            path: '/talling-manager/replenishment-inquiry/index',
            name: 'talling-manager-replenishment-inquiry-index',
            component: () =>
              import('@/views/talling-manager/replenishment-inquiry/index'),
            meta: {
              title: $t('navModules.router.merchManageMerchOrderSearch'),
              showInBreadcrumb: false,
              permission: 'REPLENISHMENT_INQUIRY'
            }
          }
        ]
      },
      {
        path: '/talling-manager/stock-log',
        name: 'talling-manager-stock-log',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.merchManageInventoryLog'),
          permission: 'TALLING_MANAGER_STOCK_LOG'
        },
        redirect: '/talling-manager/stock-log/index',
        children: [
          {
            path: '/talling-manager/stock-log/index',
            name: 'talling-manager-stock-log-index',
            component: () => import('@/views/talling-manager/stock-log/index'),
            meta: {
              title: $t('navModules.router.merchManageInventoryLog'),
              showInBreadcrumb: false,
              permission: 'TALLING_MANAGER_STOCK_LOG'
            }
          }
        ]
      },
      // {
      //   path: '/talling-manager/operation-log',
      //   name: 'talling-manager-operation-log',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '运营日志',
      //     permission: 'TALLING_MANAGER_OPERATION_LOG'
      //   },
      //   redirect: '/talling-manager/operation-log/index',
      //   children: [
      //     {
      //       path: '/talling-manager/operation-log/index',
      //       name: 'talling-manager-operation-log-index',
      //       component: () =>
      //         import('@/views/talling-manager/operation-log/index'),
      //       meta: {
      //         title: '运营日志',
      //         showInBreadcrumb: false,
      //         permission: 'TALLING_MANAGER_OPERATION_LOG'
      //       }
      //     }
      //   ]
      // },
      {
        path: '/talling-manager/replenishment-config',
        name: 'talling-manager-replenishment-config',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.merchManageRefillSettings'),
          permission: 'TALLING_MANAGER_REPLENISHMENT_CONFIG'
        },
        redirect: '/talling-manager/replenishment-config/index',
        children: [
          {
            path: '/talling-manager/replenishment-config/index',
            name: 'talling-manager-replenishment-config-index',
            component: () =>
              import('@/views/talling-manager/replenishment-config/index'),
            meta: {
              title: $t('navModules.router.merchManageRefillSettings'),
              showInBreadcrumb: false,
              permission: 'TALLING_MANAGER_REPLENISHMENT_CONFIG'
            }
          }
        ]
      }
    ]
  },
  // 积分管理
  {
    path: '/points-manager',
    name: 'points-manager',
    meta: {
      title: $t('navModules.router.pointsManage'),
      icon: 'jifenguanli',
      permission: 'POINTS_MANAGER'
    },
    redirect: '/points-manager/earn',
    children: [
      {
        path: '/points-manager/earn',
        name: 'points-manager-earn',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.pointsEarn'),
          permission: 'POINTS_EARN_RULE'
        },
        redirect: '/points-manager/earn/index',
        children: [
          {
            path: '/points-manager/earn/index',
            name: 'points-manager-earn-index',
            component: () => import('@/views/points-manager/earn/index.vue'),
            meta: {
              title: $t('navModules.router.pointsEarn'),
              showInBreadcrumb: false,
              permission: 'POINTS_EARN_RULE'
            }
          },
          {
            path: '/points-manager/earn/add',
            name: 'points-manager-earn-add',
            hidden: true,
            component: () => import('@/views/points-manager/earn/form.vue'),
            meta: {
              title: $t('pointsModules.earn.addTitle'),
              permission: 'POINTS_EARN_RULE'
            }
          },
          {
            path: '/points-manager/earn/detail',
            name: 'points-manager-earn-detail',
            hidden: true,
            component: () => import('@/views/points-manager/earn/form.vue'),
            meta: {
              title: $t('pointsModules.earn.detailTitle'),
              permission: 'POINTS_EARN_RULE'
            }
          }
        ]
      },
      {
        path: '/points-manager/redeem',
        name: 'points-manager-redeem',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.pointsRedeem'),
          permission: 'POINTS_REDEEM_RULE'
        },
        redirect: '/points-manager/redeem/index',
        children: [
          {
            path: '/points-manager/redeem/index',
            name: 'points-manager-redeem-index',
            component: () => import('@/views/points-manager/redeem/index.vue'),
            meta: {
              title: $t('navModules.router.pointsRedeem'),
              showInBreadcrumb: false,
              permission: 'POINTS_REDEEM_RULE'
            }
          },
          {
            path: '/points-manager/redeem/add',
            name: 'points-manager-redeem-add',
            hidden: true,
            component: () => import('@/views/points-manager/redeem/form.vue'),
            meta: {
              title: $t('pointsModules.redeem.addTitle'),
              permission: 'POINTS_REDEEM_RULE'
            }
          },
          {
            path: '/points-manager/redeem/detail',
            name: 'points-manager-redeem-detail',
            hidden: true,
            component: () => import('@/views/points-manager/redeem/form.vue'),
            meta: {
              title: $t('pointsModules.redeem.detailTitle'),
              permission: 'POINTS_REDEEM_RULE'
            }
          }
        ]
      },
      {
        path: '/points-manager/member',
        name: 'points-manager-member',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.pointsMember'),
          permission: 'POINTS_MEMBER'
        },
        redirect: '/points-manager/member/index',
        children: [
          {
            path: '/points-manager/member/index',
            name: 'points-manager-member-index',
            component: () => import('@/views/points-manager/member/index.vue'),
            meta: {
              title: $t('navModules.router.pointsMember'),
              showInBreadcrumb: false,
              permission: 'POINTS_MEMBER'
            }
          }
        ]
      },
      {
        path: '/points-manager/record',
        name: 'points-manager-record',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.pointsRecord'),
          permission: 'POINTS_RECORD'
        },
        redirect: '/points-manager/record/index',
        children: [
          {
            path: '/points-manager/record/index',
            name: 'points-manager-record-index',
            component: () => import('@/views/points-manager/record/index.vue'),
            meta: {
              title: $t('navModules.router.pointsRecord'),
              showInBreadcrumb: false,
              permission: 'POINTS_RECORD'
            }
          }
        ]
      }
    ]
  },
  // 结算中心
  {
    path: '/settlement-center',
    name: 'settlement-center',
    meta: {
      title: $t('navModules.router.settleCtr'),
      icon: 'jiesuanzhongxin',
      permission: 'SETTLEMENT_CENTER'
    },
    redirect: '/settlement-center/settlement-detail',
    children: [
      {
        path: '/settlement-center/settlement-detail',
        name: 'settlement-center-settlement-detail',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.settleDetails'),
          permission: 'SETTLEMENT_CENTER_DETAIL'
        },
        redirect: '/settlement-center/settlement-detail/index',
        children: [
          {
            path: '/settlement-center/settlement-detail/index',
            name: 'settlement-center-settlement-detail-index',
            component: () =>
              import('@/views/settlement-center/settlement-detail/index'),
            meta: {
              title: $t('navModules.router.settleDetails'),
              showInBreadcrumb: false,
              permission: 'SETTLEMENT_CENTER_DETAIL'
            }
          }
        ]
      },
      {
        path: '/settlement-center/contract-list',
        name: 'settlement-center-contract-list',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.installmentContract'),
          permission: 'INSTALLMENT_CONTRACT'
        },
        redirect: '/settlement-center/contract-list/index',
        children: [
          {
            path: '/settlement-center/contract-list/index',
            name: 'settlement-center-contract-list-index',
            component: () =>
              import('@/views/settlement-center/contract/contract-management/contract-list/index.vue'),
            meta: {
              title: $t('navModules.router.installmentContract'),
              showInBreadcrumb: false,
              permission: 'INSTALLMENT_CONTRACT'
            }
          },
          {
            path: '/settlement-center/contract-list/detail',
            name: 'settlement-center-contract-list-detail',
            component: () =>
              import('@/views/settlement-center/contract/contract-management/contract-detail/index.vue'),
            meta: {
              title: $t('navModules.contractDetails'),
              showInBreadcrumb: true,
              permission: 'INSTALLMENT_CONTRACT'
            }
          }
        ]
      },
      // {
      //   path: '/settlement-center/make-invoice',
      //   name: 'settlement-center-make-invoice',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: $t('settlementCenter.invoiceMgt.title'),
      //     permission: 'SETTLEMENT_CENTER_DETAIL'
      //   },
      //   redirect: '/settlement-center/make-invoice/index',
      //   children: [
      //     {
      //       path: '/settlement-center/make-invoice/index',
      //       name: 'settlement-center-make-invoice-index',
      //       component: () =>
      //         import('@/views/settlement-center/make-invoice/index.vue'),
      //       meta: {
      //         title: '',
      //         showInBreadcrumb: false,
      //         permission: 'SETTLEMENT_CENTER_DETAIL'
      //       }
      //     },
      //     // {
      //     //   path: '/settlement-center/contract-list/detail',
      //     //   name: 'settlement-center-contract-list-detail',
      //     //   component: () =>
      //     //     import('@/views/settlement-center/contract/contract-management/contract-detail/index.vue'),
      //     //   meta: {
      //     //     title: $t('navModules.contractDetails'),
      //     //     showInBreadcrumb: false,
      //     //     permission: 'SETTLEMENT_CENTER_DETAIL'
      //     //   }
      //     // }
      //   ]
      // },
      // {
      //   path: '/settlement-center/trading-detail',
      //   name: 'settlement-center-trading-detail',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '交易明细',
      //     permission: 'SETTLEMENT_CENTER_TRADING_DETAIL'
      //   },
      //   redirect: '/settlement-center/trading-detail/index',
      //   children: [
      //     {
      //       path: '/settlement-center/trading-detail/index',
      //       name: 'settlement-center-trading-detail-index',
      //       component: () =>
      //         import('@/views/settlement-center/trading-detail/index'),
      //       meta: {
      //         title: '交易明细',
      //         showInBreadcrumb: false,
      //         permission: 'SETTLEMENT_CENTER_TRADING_DETAIL'
      //       }
      //     }
      //   ]
      // }
      // {
      //   path: '/settlement-center/account-detail',
      //   name: 'settlement-center-account-detail',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '账户明细',
      //     permission: 'SETTLEMENT_CENTER_ACCOUNT_DETAIL'
      //   },
      //   redirect: '/settlement-center/account-detail/index',
      //   children: [
      //     {
      //       path: '/settlement-center/account-detail/index',
      //       name: 'settlement-center-account-detail-index',
      //       component: () =>
      //         import('@/views/settlement-center/account-detail/index'),
      //       meta: {
      //         title: '账户明细',
      //         showInBreadcrumb: false,
      //         permission: 'SETTLEMENT_CENTER_ACCOUNT_DETAIL'
      //       }
      //     },
      //     {
      //       path: '/settlement-center/account-detail/apply-withdraw',
      //       name: 'settlement-center-account-detail-apply-withdraw',
      //       component: () =>
      //         import('@/views/settlement-center/account-detail/apply-withdraw'),
      //       meta: {
      //         title: '提现',
      //         permission: 'SETTLEMENT_CENTER_ACCOUNT_DETAIL'
      //       }
      //     }
      //   ]
      // }
    ]
  },
  // 费用中心
  {
    path: '/expense-center',
    name: 'expense-center',
    meta: {
      title: $t('navModules.router.expenseCenter'),
      icon: 'feiyongzhongxin',
      permission: 'EXPENSE_CENTER'
    },
    redirect: '/expense-center/expense-account',
    children: [
      {
        path: '/expense-center/expense-account',
        name: 'expense-center-expense-account',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.expenseCenterExDetails'),
          permission: 'EXPENSE_CENTER_ACCOUNT'
        },
        redirect: '/expense-center/expense-account/index',
        children: [
          {
            path: '/expense-center/expense-account/index',
            name: 'expense-center-expense-account-index',
            component: () =>
              import('@/views/expense-center/expense-account/index'),
            meta: {
              title: $t('navModules.router.expenseCenterExDetails'),
              showInBreadcrumb: false,
              permission: 'EXPENSE_CENTER_ACCOUNT'
            }
          }
        ]
      },
      // {
      //   path: '/expense-center/subscription-service',
      //   name: 'expense-center-subscription-service',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: $t('headerModules.subscription'),
      //     permission: 'SUBSCRIPTION_SERVICE'
      //   },
      //   redirect: '/expense-center/subscription-service/index',
      //   children: [
      //     {
      //       path: '/expense-center/subscription-service/index',
      //       name: 'expense-center-subscription-service-index',
      //       component: () =>
      //         import('@/views/expense-center/subscription-service/index'),
      //       meta: {
      //         title: $t('headerModules.subscription'),
      //         showInBreadcrumb: false,
      //         permission: 'SUBSCRIPTION_SERVICE'
      //       }
      //     }
      //   ]
      // },
      // 订阅（超管专属）
      {
        path: '/expense-center/import-subscription',
        name: 'expense-center-import-subscription',
        hidden: true,
        meta: {
          title: $t('headerModules.subscription'),
          root: true
        },
        component: () =>
          import('@/views/expense-center/import-subscription/index')
      },
      // 进件管理（超管专属）
      {
        path: '/expense-center/application-management',
        name: 'expense-center-application-management',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.applicationManagement'),
          root: true
        },
        redirect: '/expense-center/application-management/index',
        children: [
          {
            path: '/expense-center/application-management/index',
            name: 'expense-center-application-management-index',
            component: () =>
              import('@/views/application-management/index'),
            meta: {
              title: $t('navModules.router.applicationManagement'),
              root: true,
              showInBreadcrumb: false
            }
          },
          {
            path: '/expense-center/application-management/mid',
            name: 'expense-center-application-management-mid',
            hidden: true,
            component: () =>
              import('@/views/application-management/mid'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/wizar/wizar-add',
            name: 'expense-center-application-management-wizar-add',
            hidden: true,
            component: () =>
              import('@/views/application-management/wizar/wizar-add'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/wizar/wizar-detail',
            name: 'expense-center-application-management-wizar-detail',
            hidden: true,
            component: () =>
              import('@/views/application-management/wizar/wizar-detail'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/pax/pax-add',
            name: 'expense-center-application-management-pax-add',
            hidden: true,
            component: () =>
              import('@/views/application-management/pax/pax-add'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/pax/pax-detail',
            name: 'expense-center-application-management-pax-detail',
            hidden: true,
            component: () =>
              import('@/views/application-management/pax/pax-detail'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/qingo-llc/qingo-add',
            name: 'expense-center-application-management-qingo-add',
            hidden: true,
            component: () =>
              import('@/views/application-management/qingo-llc/qingo-add'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          },
          {
            path: '/expense-center/application-management/qingo-llc/qingo-detail',
            name: 'expense-center-application-management-qingo-detail',
            hidden: true,
            component: () =>
              import('@/views/application-management/qingo-llc/qingo-detail'),
            meta: { title: $t('navModules.router.applicationManagement'), root: true }
          }
        ]
      },
      // {
      //   path: '/expense-center/expense-manager',
      //   name: 'expense-center-expense-manager',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '费用管理',
      //     permission: 'EXPENSE_CENTER_EXPENSE_MANAGER'
      //   },
      //   redirect: '/expense-center/expense-manager/index',
      //   children: [
      //     {
      //       path: '/expense-center/expense-manager/index',
      //       name: 'expense-center-expense-manager-index',
      //       component: () =>
      //         import('@/views/expense-center/expense-manager/index'),
      //       meta: {
      //         title: '费用管理',
      //         showInBreadcrumb: false,
      //         permission: 'EXPENSE_CENTER_EXPENSE_MANAGER'
      //       }
      //     }
      //   ]
      // },
      // {
      //   path: '/expense-center/invoice-manager',
      //   name: 'expense-center-invoice-manager',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '开票管理',
      //     permission: 'EXPENSE_CENTER_INVOICE_MANAGER'
      //   },
      //   redirect: '/expense-center/invoice-manager/index',
      //   children: [
      //     {
      //       path: '/expense-center/invoice-manager/index',
      //       name: 'expense-center-invoice-manager-index',
      //       component: () =>
      //         import('@/views/expense-center/invoice-manager/index'),
      //       meta: {
      //         title: '开票管理',
      //         showInBreadcrumb: false,
      //         permission: 'EXPENSE_CENTER_INVOICE_MANAGER'
      //       }
      //     }
      //   ]
      // }
    ]
  },
  // /* 人员管理 */
  {
    path: '/person-manager',
    name: 'personManager',
    redirect: '/person-manager/org-manager',
    meta: {
      title: $t('navModules.router.userManager'),
      icon: 'renyuanguanli',
      permission: 'PERSON_MANAGER'
    },
    children: [
      /* 组织管理 */
      {
        path: '/person-manager/org-manager',
        name: 'orgManager',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.orgManager'),
          permission: 'ORG_MANAGER'
        },
        children: [
          {
            path: '/person-manager/org-manager',
            name: 'orgManagerIndex',
            component: () => import('@/views/person-manager/org-manager/refactoring/index.vue'),
            meta: {
              title: $t('navModules.router.orgManager'),
              permission: 'ORG_MANAGER',
              showInBreadcrumb: false
            }
          }
        ]
      },
      /* 角色管理 */
      {
        path: '/person-manager/roles-manager',
        name: 'rolesManager',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.roleManager'),
          permission: 'ROLES_MANAGER'
        },
        children: [
          {
            path: '/person-manager/roles-manager',
            name: 'rolesManagerIndex',
            component: () => import('@/views/person-manager/roles-manager'),
            meta: {
              title: $t('navModules.router.roleManager'),
              permission: 'ROLES_MANAGER',
              showInBreadcrumb: false
            }
          }
        ]
      }
      /*TODO 本期暂缓 消息管理 */
      // {
      //   path: '/person-manager/message-manager',
      //   name: 'messageManager',
      //   hideChildrenInMenu: true,
      //   meta: {
      //     title: '消息管理',
      //     permission: 'MESSAGE_MANAGER'
      //   },
      //   children: [
      //     {
      //       path: '/person-manager/message-manager',
      //       name: 'messageManagerIndex',
      //       component: () => import('@/views/person-manager/message-manager'),
      //       meta: {
      //         title: '消息管理',
      //         permission: 'MESSAGE_MANAGER',
      //         showInBreadcrumb: false
      //       }
      //     }
      //   ]
      // }
    ]
  },

  // /* 系统设置 */
  {
    path: '/system-settings',
    name: 'systemSettings',
    redirect: '/system-settings/merchant-config',
    meta: {
      title: $t('navModules.router.systemSettings'),
      icon: 'xilongshezhi',
      permission: 'SYSTEM_MANAGER'
    },
    children: [
      /* 商户配置 */
      {
        path: '/system-settings/merchant-config',
        name: 'systemSettingsMerchantConfig',
        redirect: '/system-settings/merchant-config/index',
        hideChildrenInMenu: true,
        meta: {
          title: $t('navModules.router.merchantConfig'),
          permission: 'MCTCONFIG_MANAGER'
        },
        children: [
          {
            path: '/system-settings/merchant-config/index',
            name: 'systemSettingsMerchantConfigIndex',
            component: () => import('@/views/system-settings/merchant-config/index'),
            meta: {
              title: $t('navModules.router.merchantConfig'),
              permission: 'MCTCONFIG_MANAGER',
              showInBreadcrumb: false
            }
          }
        ]
      }
    ]
  },

  // /* 算法对账 */
  // {
  //   path: '/algorithm-manage',
  //   name: 'algorithm-manage',
  //   redirect: '/algorithm-manager/invoice-manage',
  //   meta: {
  //     title: '算法对账',
  //     icon: 'feiyongzhongxin',
  //     permission: 'ALGORITHM_MANAGE'
  //   },
  //   children: [
  //     {
  //       path: '/algorithm-manager/invoice-manage',
  //       name: 'algorithm-manager-invoice-manage',
  //       hideChildrenInMenu: true,
  //       meta: {
  //         title: '开票管理',
  //         permission: 'ALGORITHM_INVOICE_MANAGE',
  //         showInBreadcrumb: true
  //       },
  //       component: () => import('@/views/algorithm-manage/invoice-manage/index.vue')
  //     },
  //     {
  //       path: '/algorithm-manager/cost-details',
  //       name: 'algorithm-manager-cost-details',
  //       hideChildrenInMenu: true,
  //       meta: {
  //         title: '费用明细',
  //         permission: 'ALGORITHM_COST_DETAILS',
  //         showInBreadcrumb: true
  //       },
  //       component: () => import('@/views/algorithm-manage/cost-details/index.vue')
  //     }
  //   ]
  // }
]

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/user/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/secret-login',
    name: 'secret-login',
    component: () => import('@/views/secret-login/index.vue'),
    meta: {
      title: '超管登录'
    }
  },
  // { path: '/*', name: '404', component: () => import('@/views/exception/404') }
]
